import { useState } from "react";
import { Link } from "react-router-dom";

const categories = ["All", "Balayage", "Color", "Cuts", "Extensions", "Bridal"];

const portfolio = [
  { id: 1, cat: "Balayage", label: "Honey Balayage", stylist: "Isabelle Fontaine", image: "https://public.readdy.ai/ai/img_res/ad246498c7e5d6176c2a4d29d6988102.jpg" },
  { id: 2, cat: "Color", label: "Platinum Transformation", stylist: "Margot Delacroix", image: "https://readdy.ai/api/search-image?query=professional%20salon%20portfolio%20platinum%20blonde%20hair%20transformation%20stunning%20woman%2C%20icy%20cool%20tones%2C%20luxury%20glamorous%20salon%20Las%20Vegas%2C%20clean%20background%2C%20high%20fashion%20editorial%20beauty%20photography&width=600&height=800&seq=port2&orientation=portrait" },
  { id: 3, cat: "Bridal", label: "Bridal Updo", stylist: "Sofia Ricci", image: "https://readdy.ai/api/search-image?query=elegant%20bridal%20updo%20hairstyle%20bride%20soft%20romantic%20chignon%20luxury%20wedding%20hair%2C%20white%20floral%20accessories%2C%20warm%20cream%20background%2C%20European%20salon%20craft%2C%20beauty%20editorial%20photography%20close%20up&width=600&height=800&seq=port3&orientation=portrait" },
  { id: 4, cat: "Cuts", label: "Precision Lob", stylist: "Elena Vasquez", image: "https://readdy.ai/api/search-image?query=sleek%20precision%20lob%20haircut%20bob%20sophisticated%20woman%20luxury%20hair%20salon%2C%20glossy%20smooth%20straight%20hair%2C%20neutral%20background%2C%20European%20haircut%20artistry%2C%20beauty%20editorial%20clean%20photography&width=600&height=800&seq=port4&orientation=portrait" },
  { id: 5, cat: "Extensions", label: "Volume Extensions", stylist: "Isabelle Fontaine", image: "https://readdy.ai/api/search-image?query=luxury%20hair%20extensions%20glamorous%20long%20voluminous%20waves%20woman%20Las%20Vegas%20salon%2C%20rich%20brown%20caramel%20tones%2C%20editorial%20beauty%20photography%2C%20elegant%20styled%2C%20soft%20studio%20background&width=600&height=800&seq=port5&orientation=portrait" },
  { id: 6, cat: "Balayage", label: "Rose Gold Balayage", stylist: "Sofia Ricci", image: "https://readdy.ai/api/search-image?query=rose%20gold%20balayage%20hair%20color%20technique%20beautiful%20woman%2C%20European%20hair%20salon%20luxury%2C%20warm%20pink%20golden%20tones%20on%20brunette%20hair%2C%20editorial%20photography%2C%20clean%20studio%20background&width=600&height=800&seq=port6&orientation=portrait" },
  { id: 7, cat: "Color", label: "Dimensional Brunette", stylist: "Margot Delacroix", image: "https://readdy.ai/api/search-image?query=dimensional%20brunette%20hair%20color%20rich%20chocolate%20tones%20glossy%20waves%20woman%20luxury%20salon%20Las%20Vegas%2C%20European%20color%20technique%2C%20beauty%20editorial%20photography%2C%20dark%20neutral%20background&width=600&height=800&seq=port7&orientation=portrait" },
  { id: 8, cat: "Cuts", label: "Textured Layers", stylist: "Elena Vasquez", image: "https://readdy.ai/api/search-image?query=textured%20layered%20haircut%20woman%20medium%20length%20hair%20movement%20natural%20beach%20waves%20luxury%20salon%2C%20European%20cut%20technique%2C%20editorial%20beauty%20photography%2C%20light%20clean%20background&width=600&height=800&seq=port8&orientation=portrait" },
];

export default function PortfolioShowcase() {
  const [active, setActive] = useState("All");

  const filtered = active === "All" ? portfolio : portfolio.filter((p) => p.cat === active);

  return (
    <section className="w-full bg-[#faf8f5] py-24 px-6" id="portfolio">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">Our Work</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
            Portfolio Showcase
          </h2>
          <p className="text-neutral-500 mt-4 text-sm max-w-md mx-auto leading-relaxed">
            Every look is a masterclass in European technique — tailored to your individuality.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`px-5 py-2 text-xs font-semibold tracking-widest uppercase rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap ${
                active === cat
                  ? "bg-[#C9A96E] text-white"
                  : "bg-white text-neutral-600 border border-neutral-200 hover:border-[#C9A96E] hover:text-[#C9A96E]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.map((item) => (
            <div key={item.id} className="group relative overflow-hidden rounded-lg cursor-pointer">
              <div className="w-full h-72 md:h-80 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <p className="text-white text-sm font-semibold">{item.label}</p>
                <p className="text-[#C9A96E] text-xs mt-0.5">{item.stylist}</p>
              </div>
              <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-black/30 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-zoom-in-line text-white text-sm"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/portfolio"
            className="inline-block border border-[#C9A96E] text-[#C9A96E] text-sm font-semibold tracking-widest uppercase px-12 py-4 rounded-sm hover:bg-[#C9A96E] hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            View Full Portfolio
          </Link>
        </div>
      </div>
    </section>
  );
}
